<template>
  <div v-if="load" style="border:none; background-color:  transparent;" >
    <span> <scale-loader /> </span>
  </div>

  <div v-else class="roles_and_permissions">
    <div class="tab">
      <span
          class="tab_title"
          :class="{ active : block==='Roles'}"
          @click="selected_block('Roles')">
        {{this.translate('user.roles.role_list')}}
      </span>
      <span
          class="tab_title"
          :class="{ active : block==='Permissions'}"
          @click="selected_block('Permissions')"
      >
        {{this.translate('user.roles.permission_list')}}
      </span>
    </div>
    <div class="block">
      <RoleList
          v-if="block==='Roles'"
          :role_list="role_list"
          :permission_list="permission_list"
      />
      <PermissionList
          v-if="block==='Permissions'"
          :permission_list="permission_list"
      />
    </div>
  </div>
</template>

<script>
import RoleList from "@/views/Dashboard/common/General/UserManagment/RolesAndPermissions/RoleList.vue";
import PermissionList from "@/views/Dashboard/common/General/UserManagment/RolesAndPermissions/PermissionList.vue";

export default {
  name: 'RolesAndPermissions',
  props: ['role_list', 'permission_list'],

  components: {
    RoleList,
    PermissionList
  },

  data () {
    return {
      block: 'Roles',
    }
  },
  computed:{
    load(){
      return Object.keys(this.role_list).length < 1 && Object.keys(this.permission_list).length < 1
    }
  },
  methods: {
    selected_block(block){
      this.block = block
    }
  }
}

</script>

<style lang="scss" scoped>
.roles_and_permissions{
  height: 100%;
  .tab{
    width: 100%;
    height: 5%;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: row;
    &_title{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      background-color: #efe9e9;
      border: 1px solid #efe9e9;
      &.active{
        background-color: #f8f8f8;
        border-bottom: 1px solid #f8f8f8;
      }
    }
  }
  .block{
    height: 95%;
    border: 1px solid #efe9e9;
    margin-top: -1px;
    padding: 10px;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
}

</style>
